module.exports = __webpack_public_path__ + "static/media/logo-mesa-de-trabajo-1@3x.494a1ab5.png";